export default "__VITE_ASSET__PQ0BxUgZ__"